module.exports = __webpack_public_path__ + "img/end-header-background-ms.1e91a01f.png";